import { useEffect } from "react";
import { doc, setDoc, updateDoc, getDoc, increment } from "firebase/firestore";
import { db } from "../firebase";

export default function useVisitorTracker(pathname) {
  useEffect(() => {
    const trackVisit = async () => {
      const today = new Date().toISOString().split("T")[0];
      const docRef = doc(db, "visiteurs", today);
      const snap = await getDoc(docRef);

      const sanitizedPath = pathname.replace(/\//g, "_"); // "/a-propos" devient "_a-propos"

      if (!snap.exists()) {
        await setDoc(docRef, {
          date: today,
          total: 1,
          pages: {
            [sanitizedPath]: 1,
          },
        });
      } else {
        await updateDoc(docRef, {
          total: increment(1),
          [`pages.${sanitizedPath}`]: increment(1), // clé valide
        });
      }
    };

    trackVisit();
  }, [pathname]);
}
